export default __webpack_public_path__ + "static/media/trash.06af6b15.svg";